export const compareObjectsPartially = <T extends Record<string, unknown>>(
  obj1: T,
  obj2: T,
  keys: (keyof T)[]
): boolean => {
  return !keys.some((key) => obj1[key] !== obj2[key]);
};

export const compareObjectsOmitProps = <T extends Record<string, unknown>>(
  obj1: T,
  obj2: T,
  keys: (keyof T)[]
): boolean => {
  return !Object.keys(obj1).some((key) => !keys.includes(key) && obj1[key] !== obj2[key]);
};

export const objectToHash = (obj: object) => {
  const jsonString = JSON.stringify(obj ?? null);
  let hash = 0;
  for (let i = 0; i < jsonString.length; i++) {
    hash = (hash << 5) - hash + jsonString.charCodeAt(i);
    hash |= 0;
  }
  return hash >>> 0;
};
